import { render, staticRenderFns } from "./IndoorHeatmap.vue?vue&type=template&id=31503450&scoped=true"
import script from "./IndoorHeatmap.vue?vue&type=script&lang=js"
export * from "./IndoorHeatmap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31503450",
  null
  
)

export default component.exports